import { assertEvent } from 'xstate5';

import { type Guard } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

export const checkIfRequiredModification: Guard = function (args): boolean {
  const { context, event } = args;

  assertEvent(event, [
    'customization.remove-modification',
    'customization.remove-modification-completely',
  ]);

  const { ingredientId } = event;

  const modification = context.allModificationsMap?.get(ingredientId);
  const modificationGroup = context.modificationGroups?.find(
    (group) => group.id === modification?.modificationGroupId,
  );

  if (!modificationGroup) return false;

  return (
    modificationGroup.minAggregateQuantity === 1 &&
    modificationGroup.maxAggregateQuantity === 1 &&
    modificationGroup.modifications.length === 1
  );
};
